import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styled from '@emotion/styled';
import { Trash2 } from 'lucide-react';

const MedicationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const SectionTitle = styled.h2`
  width: 100%;
  font-family: 'Sofia Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #6D6D71;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 20px;
  background: #FFFFFF;
  border: 1px solid #C5C5C6;
  border-radius: 12px;
`;

const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

// const CheckboxLabel = styled.label`
//   display: flex;
//   align-items: center;
//   cursor: pointer;
//   font-family: 'Sofia Sans', sans-serif;
//   font-size: 16px;
//   color: #2C2C2D;
// `;

const StyledCheckbox = styled.input`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-family: 'Sofia Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #2C2C2D;
  cursor: pointer;
`;
const OtherMedicationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const OtherMedicationInputGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  width: 300px;
`;

const InputWrapper = styled.div`
  flex-grow: 1;
`;

const OtherMedicationInput = styled.input`
  font-family: 'Sofia Pro', sans-serif;
  width: 250px;
  padding: 18px 16px;
  border: 1px solid #A7A7AA;
  border-radius: 12px;
`;

const AddButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 12px;
  width: 250px;
  height: 54px;
  background: #FFFFFF;
  border: 1px solid #A7A7AA;
  border-radius: 16px;
  font-family: 'Sofia Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #2C2C2D;
  cursor: pointer;
  font-family: 'Sofia Pro', sans-serif;
  transition: background-color 0.3s ease;

  
`;

const DeleteButton = styled.button`
  width: 50px;
  height: 50px;
  border: 1px solid #EF8585;
  border-radius: 4px;
  margin-left: 10px;
  background: none;
  cursor: pointer;
`;

const medicationsList = [
  'ACEI', 'ARB', 'Beta Blockers', 'DHP CCB', 'Non-DHP CCB',
  'Diuretics', 'Hydralazine', 'Nitrates', 'Digoxin', 'Warfarin', 'DOAC', 'Other'
];

const Medications = ({ medications, setMedications }) => {
  const [showOther, setShowOther] = useState(false);

  // Check if there are any custom medications on mount and when medications change
  useEffect(() => {
    const hasCustomMedications = medications.some(med => !medicationsList.includes(med));
    if (hasCustomMedications && !showOther) {
      setShowOther(true);
    }
  }, [medications, showOther]);

  const handleMedicationChange = (medication) => {
    if (medication === 'Other') {
      setShowOther(!showOther);
    } else {
      if (medications.includes(medication)) {
        setMedications(medications.filter(med => med !== medication));
        console.log(medications);
      } else {
        setMedications([...medications, medication]);
        console.log(medications);
      }
    }
  };

  const addOtherMedication = (e) => {
    e.preventDefault(); // Prevent form submission
    setMedications([...medications, '']);
  };

  const handleOtherMedicationChange = (index, value) => {
    const newMedications = [...medications];
    newMedications[index] = value;
    setMedications(newMedications);
  };

  const removeOtherMedication = (index) => {
    const newMedications = [...medications];
    newMedications.splice(index, 1);
    setMedications(newMedications);
  };

  return (
    <MedicationsContainer>
      <SectionTitle>MEDICATIONS</SectionTitle>
      <ContentBox>
        <CheckboxGroup>
          {medicationsList.map((medication) => (
            <CheckboxLabel key={medication}>
              <StyledCheckbox
                type="checkbox"
                checked={medication === 'Other' ? showOther : medications.includes(medication)}
                onChange={() => handleMedicationChange(medication)}
              />
              {medication}
            </CheckboxLabel>
          ))}
        </CheckboxGroup>

        {showOther && (
          <OtherMedicationsContainer>
            {medications.map((med, index) => {
              if (medicationsList.includes(med)) return null;
              return (
                <OtherMedicationInputGroup key={index}>
                  <InputWrapper>
                    <OtherMedicationInput
                      type="text"
                      value={med}
                      onChange={(e) => handleOtherMedicationChange(index, e.target.value)}
                      placeholder="Enter other medication"
                    />
                  </InputWrapper>
                  <DeleteButton type="button" onClick={() => removeOtherMedication(index)}>
                    <Trash2 size={20}  color="#EF8585" />
                  </DeleteButton>
                </OtherMedicationInputGroup>
              );
            })}
            <AddButton type="button" onClick={addOtherMedication}>
              + Add Other Medication
            </AddButton>
          </OtherMedicationsContainer>
        )}
      </ContentBox>
    </MedicationsContainer>
  );
};

export default Medications;



